import {
  Companion_getInstance2m617r7l2yg9j as Companion_getInstance,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Party3ik5jb5ehc552 as Party,
  PaymentState2oe0svpo60h08 as PaymentState,
} from './enums.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd as _MonetaryValue___init__impl__jsc11x,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from './supportModels.mjs';
import { PaymentTransferMethod2houca3ect5kw as PaymentTransferMethod } from './paymentModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectLedgerItem_project_getInstance());
}
function get_party(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectLedgerItem_party_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectLedgerItem_state_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectLedgerItem_created_getInstance());
}
function get_amount(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectLedgerItem_amount_getInstance());
}
function prepareProjectLedgerItemFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ProjectLedgerItem__id_getInstance(), ProjectLedgerItem_project_getInstance(), ProjectLedgerItem_lineItem_getInstance(), ProjectLedgerItem_payApp_getInstance(), ProjectLedgerItem_party_getInstance(), ProjectLedgerItem_amount_getInstance(), ProjectLedgerItem_contractorFee_getInstance(), ProjectLedgerItem_platformFee_getInstance(), ProjectLedgerItem_processorFee_getInstance(), ProjectLedgerItem_state_getInstance(), ProjectLedgerItem_message_getInstance(), ProjectLedgerItem_method_getInstance(), ProjectLedgerItem_depositSucceeded_getInstance(), ProjectLedgerItem_payoutRequested_getInstance(), ProjectLedgerItem_payoutConfirmation_getInstance(), ProjectLedgerItem_accountName_getInstance(), ProjectLedgerItem_intentId_getInstance(), ProjectLedgerItem_check_getInstance(), ProjectLedgerItem_created_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function ProjectLedgerItem_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function ProjectLedgerItem_project$_get_name_$ref_68ndks() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_project$_get_serializer_$ref_adeau5() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function ProjectLedgerItem_project$_get_annotations_$ref_lb61jb() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_projectClass;
function ProjectLedgerItem_project() {
  if (ProjectLedgerItem_projectClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_project_instance = this;
        var tmp = this;
        tmp.j7k_1 = lazy(ProjectLedgerItem_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k7k_1 = lazy(ProjectLedgerItem_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l7k_1 = lazy(ProjectLedgerItem_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.j7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_project$_get_name_$ref_68ndks(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.o7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      g7l(receiver, value) {
        return receiver.h7l(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.g7l(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.k7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_project$_get_serializer_$ref_adeau5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l7k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_project$_get_annotations_$ref_lb61jb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_project', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_projectClass = $;
  }
  return ProjectLedgerItem_projectClass;
}
var ProjectLedgerItem_project_instance;
function ProjectLedgerItem_project_getInstance() {
  if (ProjectLedgerItem_project_instance === VOID)
    new (ProjectLedgerItem_project())();
  return ProjectLedgerItem_project_instance;
}
function ProjectLedgerItem_party$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function ProjectLedgerItem_party$_get_name_$ref_5dumax() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_party$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_party$_get_serializer_$ref_4gfmj4() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_party$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function ProjectLedgerItem_party$_get_annotations_$ref_c6xd0s() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_partyClass;
function ProjectLedgerItem_party() {
  if (ProjectLedgerItem_partyClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_party_instance = this;
        var tmp = this;
        tmp.i7l_1 = lazy(ProjectLedgerItem_party$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j7l_1 = lazy(ProjectLedgerItem_party$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k7l_1 = lazy(ProjectLedgerItem_party$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.i7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_party$_get_name_$ref_5dumax(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.r7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      l7l(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.l7l(tmp, value instanceof Party() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_party$_get_serializer_$ref_4gfmj4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_party$_get_annotations_$ref_c6xd0s(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_party', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_partyClass = $;
  }
  return ProjectLedgerItem_partyClass;
}
var ProjectLedgerItem_party_instance;
function ProjectLedgerItem_party_getInstance() {
  if (ProjectLedgerItem_party_instance === VOID)
    new (ProjectLedgerItem_party())();
  return ProjectLedgerItem_party_instance;
}
function ProjectLedgerItem_state$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function ProjectLedgerItem_state$_get_name_$ref_g3v1qk() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_state$_get_serializer_$ref_xpftln() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_state$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function ProjectLedgerItem_state$_get_annotations_$ref_4gd9hb() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_stateClass;
function ProjectLedgerItem_state() {
  if (ProjectLedgerItem_stateClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_state_instance = this;
        var tmp = this;
        tmp.m7l_1 = lazy(ProjectLedgerItem_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n7l_1 = lazy(ProjectLedgerItem_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o7l_1 = lazy(ProjectLedgerItem_state$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.m7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_state$_get_name_$ref_g3v1qk(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.w7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      p7l(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.p7l(tmp, value instanceof PaymentState() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_state$_get_serializer_$ref_xpftln(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_state$_get_annotations_$ref_4gd9hb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_state', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_stateClass = $;
  }
  return ProjectLedgerItem_stateClass;
}
var ProjectLedgerItem_state_instance;
function ProjectLedgerItem_state_getInstance() {
  if (ProjectLedgerItem_state_instance === VOID)
    new (ProjectLedgerItem_state())();
  return ProjectLedgerItem_state_instance;
}
function ProjectLedgerItem_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(18);
}
function ProjectLedgerItem_created$_get_name_$ref_ahx4x7() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[18];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_created$_get_serializer_$ref_9mm3u6() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(18);
}
function ProjectLedgerItem_created$_get_annotations_$ref_1r3zfu() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_createdClass;
function ProjectLedgerItem_created() {
  if (ProjectLedgerItem_createdClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_created_instance = this;
        var tmp = this;
        tmp.q7l_1 = lazy(ProjectLedgerItem_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r7l_1 = lazy(ProjectLedgerItem_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s7l_1 = lazy(ProjectLedgerItem_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.t7l_1 = get_default(Companion_instance).b1m();
        this.u7l_1 = 'now()';
      }
      i20() {
        var tmp0 = this.q7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_created$_get_name_$ref_ahx4x7(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.f7l_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      v7l(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.v7l(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_created$_get_serializer_$ref_9mm3u6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_created$_get_annotations_$ref_1r3zfu(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_created', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_createdClass = $;
  }
  return ProjectLedgerItem_createdClass;
}
var ProjectLedgerItem_created_instance;
function ProjectLedgerItem_created_getInstance() {
  if (ProjectLedgerItem_created_instance === VOID)
    new (ProjectLedgerItem_created())();
  return ProjectLedgerItem_created_instance;
}
function ProjectLedgerItem_amount$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function ProjectLedgerItem_amount$_get_name_$ref_3fttzl() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_amount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_amount$_get_serializer_$ref_ppvyl2() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_amount$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function ProjectLedgerItem_amount$_get_annotations_$ref_w1z8x2() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_amountClass;
function ProjectLedgerItem_amount() {
  if (ProjectLedgerItem_amountClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_amount_instance = this;
        var tmp = this;
        tmp.w7l_1 = lazy(ProjectLedgerItem_amount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7l_1 = lazy(ProjectLedgerItem_amount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7l_1 = lazy(ProjectLedgerItem_amount$annotations$delegate$lambda);
        this.z7l_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.a7m_1 = 'MonetaryValue(0)';
      }
      i20() {
        var tmp0 = this.w7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_amount$_get_name_$ref_3fttzl(), null);
        return tmp0.f2();
      }
      b7m(receiver) {
        return receiver.s7k_1;
      }
      k2j(receiver) {
        return new (MonetaryValue())(this.b7m(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE()));
      }
      c7m(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.c7m(tmp, value instanceof MonetaryValue() ? value.y5r_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_amount$_get_serializer_$ref_ppvyl2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_amount$_get_annotations_$ref_w1z8x2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_amount', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_amountClass = $;
  }
  return ProjectLedgerItem_amountClass;
}
var ProjectLedgerItem_amount_instance;
function ProjectLedgerItem_amount_getInstance() {
  if (ProjectLedgerItem_amount_instance === VOID)
    new (ProjectLedgerItem_amount())();
  return ProjectLedgerItem_amount_instance;
}
function ProjectLedgerItem__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function ProjectLedgerItem__id$_get_name_$ref_54qbb7() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem__id$_get_serializer_$ref_w8f598() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function ProjectLedgerItem__id$_get_annotations_$ref_ba8b88() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem__idClass;
function ProjectLedgerItem__id() {
  if (ProjectLedgerItem__idClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem__id_instance = this;
        var tmp = this;
        tmp.d7m_1 = lazy(ProjectLedgerItem__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e7m_1 = lazy(ProjectLedgerItem__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f7m_1 = lazy(ProjectLedgerItem__id$annotations$delegate$lambda);
        this.g7m_1 = Companion_getInstance_0().k2p();
        this.h7m_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.d7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem__id$_get_name_$ref_54qbb7(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.n7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      g7l(receiver, value) {
        return receiver.h7l(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.g7l(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.e7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem__id$_get_serializer_$ref_w8f598(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem__id$_get_annotations_$ref_ba8b88(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem__id', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem__idClass = $;
  }
  return ProjectLedgerItem__idClass;
}
var ProjectLedgerItem__id_instance;
function ProjectLedgerItem__id_getInstance() {
  if (ProjectLedgerItem__id_instance === VOID)
    new (ProjectLedgerItem__id())();
  return ProjectLedgerItem__id_instance;
}
function ProjectLedgerItem_lineItem$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function ProjectLedgerItem_lineItem$_get_name_$ref_9hpkpq() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_lineItem$_get_serializer_$ref_y0oqj() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function ProjectLedgerItem_lineItem$_get_annotations_$ref_d6w8bt() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_lineItemClass;
function ProjectLedgerItem_lineItem() {
  if (ProjectLedgerItem_lineItemClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_lineItem_instance = this;
        var tmp = this;
        tmp.i7m_1 = lazy(ProjectLedgerItem_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j7m_1 = lazy(ProjectLedgerItem_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k7m_1 = lazy(ProjectLedgerItem_lineItem$annotations$delegate$lambda);
        this.l7m_1 = null;
        this.m7m_1 = 'null';
      }
      i20() {
        var tmp0 = this.i7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_lineItem$_get_name_$ref_9hpkpq(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.p7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      n7m(receiver, value) {
        return receiver.h7l(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.n7m(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_lineItem$_get_serializer_$ref_y0oqj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_lineItem$_get_annotations_$ref_d6w8bt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_lineItem', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_lineItemClass = $;
  }
  return ProjectLedgerItem_lineItemClass;
}
var ProjectLedgerItem_lineItem_instance;
function ProjectLedgerItem_lineItem_getInstance() {
  if (ProjectLedgerItem_lineItem_instance === VOID)
    new (ProjectLedgerItem_lineItem())();
  return ProjectLedgerItem_lineItem_instance;
}
function ProjectLedgerItem_payApp$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function ProjectLedgerItem_payApp$_get_name_$ref_9y1be8() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_payApp$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_payApp$_get_serializer_$ref_pqbxl5() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_payApp$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function ProjectLedgerItem_payApp$_get_annotations_$ref_8c8yj() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_payAppClass;
function ProjectLedgerItem_payApp() {
  if (ProjectLedgerItem_payAppClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_payApp_instance = this;
        var tmp = this;
        tmp.o7m_1 = lazy(ProjectLedgerItem_payApp$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p7m_1 = lazy(ProjectLedgerItem_payApp$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q7m_1 = lazy(ProjectLedgerItem_payApp$annotations$delegate$lambda);
        this.r7m_1 = null;
        this.s7m_1 = 'null';
      }
      i20() {
        var tmp0 = this.o7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_payApp$_get_name_$ref_9y1be8(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.q7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      n7m(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.n7m(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_payApp$_get_serializer_$ref_pqbxl5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_payApp$_get_annotations_$ref_8c8yj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_payApp', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_payAppClass = $;
  }
  return ProjectLedgerItem_payAppClass;
}
var ProjectLedgerItem_payApp_instance;
function ProjectLedgerItem_payApp_getInstance() {
  if (ProjectLedgerItem_payApp_instance === VOID)
    new (ProjectLedgerItem_payApp())();
  return ProjectLedgerItem_payApp_instance;
}
function ProjectLedgerItem_contractorFee$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function ProjectLedgerItem_contractorFee$_get_name_$ref_sa8pxo() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_contractorFee$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_contractorFee$_get_serializer_$ref_jdi47v() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_contractorFee$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function ProjectLedgerItem_contractorFee$_get_annotations_$ref_mjpshr() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_contractorFeeClass;
function ProjectLedgerItem_contractorFee() {
  if (ProjectLedgerItem_contractorFeeClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_contractorFee_instance = this;
        var tmp = this;
        tmp.t7m_1 = lazy(ProjectLedgerItem_contractorFee$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u7m_1 = lazy(ProjectLedgerItem_contractorFee$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v7m_1 = lazy(ProjectLedgerItem_contractorFee$annotations$delegate$lambda);
        this.w7m_1 = null;
        this.x7m_1 = 'null';
      }
      i20() {
        var tmp0 = this.t7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_contractorFee$_get_name_$ref_sa8pxo(), null);
        return tmp0.f2();
      }
      y7m(receiver) {
        return receiver.t7k_1;
      }
      k2j(receiver) {
        var tmp = this.y7m(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      z7m(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.y5r_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.z7m(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.u7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_contractorFee$_get_serializer_$ref_jdi47v(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v7m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_contractorFee$_get_annotations_$ref_mjpshr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_contractorFee', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_contractorFeeClass = $;
  }
  return ProjectLedgerItem_contractorFeeClass;
}
var ProjectLedgerItem_contractorFee_instance;
function ProjectLedgerItem_contractorFee_getInstance() {
  if (ProjectLedgerItem_contractorFee_instance === VOID)
    new (ProjectLedgerItem_contractorFee())();
  return ProjectLedgerItem_contractorFee_instance;
}
function ProjectLedgerItem_platformFee$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function ProjectLedgerItem_platformFee$_get_name_$ref_4e7sy2() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_platformFee$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_platformFee$_get_serializer_$ref_8om4il() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_platformFee$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function ProjectLedgerItem_platformFee$_get_annotations_$ref_16aqm7() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_platformFeeClass;
function ProjectLedgerItem_platformFee() {
  if (ProjectLedgerItem_platformFeeClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_platformFee_instance = this;
        var tmp = this;
        tmp.a7n_1 = lazy(ProjectLedgerItem_platformFee$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b7n_1 = lazy(ProjectLedgerItem_platformFee$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c7n_1 = lazy(ProjectLedgerItem_platformFee$annotations$delegate$lambda);
        this.d7n_1 = null;
        this.e7n_1 = 'null';
      }
      i20() {
        var tmp0 = this.a7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_platformFee$_get_name_$ref_4e7sy2(), null);
        return tmp0.f2();
      }
      y7m(receiver) {
        return receiver.u7k_1;
      }
      k2j(receiver) {
        var tmp = this.y7m(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      z7m(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.y5r_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.z7m(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.b7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_platformFee$_get_serializer_$ref_8om4il(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_platformFee$_get_annotations_$ref_16aqm7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_platformFee', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_platformFeeClass = $;
  }
  return ProjectLedgerItem_platformFeeClass;
}
var ProjectLedgerItem_platformFee_instance;
function ProjectLedgerItem_platformFee_getInstance() {
  if (ProjectLedgerItem_platformFee_instance === VOID)
    new (ProjectLedgerItem_platformFee())();
  return ProjectLedgerItem_platformFee_instance;
}
function ProjectLedgerItem_processorFee$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function ProjectLedgerItem_processorFee$_get_name_$ref_b7j6zv() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_processorFee$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_processorFee$_get_serializer_$ref_j4b7ce() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_processorFee$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function ProjectLedgerItem_processorFee$_get_annotations_$ref_8d1tcm() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_processorFeeClass;
function ProjectLedgerItem_processorFee() {
  if (ProjectLedgerItem_processorFeeClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_processorFee_instance = this;
        var tmp = this;
        tmp.f7n_1 = lazy(ProjectLedgerItem_processorFee$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g7n_1 = lazy(ProjectLedgerItem_processorFee$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h7n_1 = lazy(ProjectLedgerItem_processorFee$annotations$delegate$lambda);
        this.i7n_1 = null;
        this.j7n_1 = 'null';
      }
      i20() {
        var tmp0 = this.f7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_processorFee$_get_name_$ref_b7j6zv(), null);
        return tmp0.f2();
      }
      y7m(receiver) {
        return receiver.v7k_1;
      }
      k2j(receiver) {
        var tmp = this.y7m(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      z7m(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.y5r_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.z7m(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.g7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_processorFee$_get_serializer_$ref_j4b7ce(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_processorFee$_get_annotations_$ref_8d1tcm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_processorFee', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_processorFeeClass = $;
  }
  return ProjectLedgerItem_processorFeeClass;
}
var ProjectLedgerItem_processorFee_instance;
function ProjectLedgerItem_processorFee_getInstance() {
  if (ProjectLedgerItem_processorFee_instance === VOID)
    new (ProjectLedgerItem_processorFee())();
  return ProjectLedgerItem_processorFee_instance;
}
function ProjectLedgerItem_message$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function ProjectLedgerItem_message$_get_name_$ref_y9e23u() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_message$_get_serializer_$ref_uh07jj() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_message$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function ProjectLedgerItem_message$_get_annotations_$ref_550pmd() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_messageClass;
function ProjectLedgerItem_message() {
  if (ProjectLedgerItem_messageClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_message_instance = this;
        var tmp = this;
        tmp.k7n_1 = lazy(ProjectLedgerItem_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l7n_1 = lazy(ProjectLedgerItem_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m7n_1 = lazy(ProjectLedgerItem_message$annotations$delegate$lambda);
        this.n7n_1 = null;
        this.o7n_1 = 'null';
      }
      i20() {
        var tmp0 = this.k7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_message$_get_name_$ref_y9e23u(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.x7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      p7n(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.p7n(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_message$_get_serializer_$ref_uh07jj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_message$_get_annotations_$ref_550pmd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_message', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_messageClass = $;
  }
  return ProjectLedgerItem_messageClass;
}
var ProjectLedgerItem_message_instance;
function ProjectLedgerItem_message_getInstance() {
  if (ProjectLedgerItem_message_instance === VOID)
    new (ProjectLedgerItem_message())();
  return ProjectLedgerItem_message_instance;
}
function ProjectLedgerItem_method$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function ProjectLedgerItem_method$_get_name_$ref_op8j2w() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_method$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_method$_get_serializer_$ref_4pnnb3() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_method$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function ProjectLedgerItem_method$_get_annotations_$ref_k4u13x() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_methodClass;
function ProjectLedgerItem_method() {
  if (ProjectLedgerItem_methodClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_method_instance = this;
        var tmp = this;
        tmp.q7n_1 = lazy(ProjectLedgerItem_method$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r7n_1 = lazy(ProjectLedgerItem_method$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s7n_1 = lazy(ProjectLedgerItem_method$annotations$delegate$lambda);
        this.t7n_1 = null;
        this.u7n_1 = 'null';
      }
      i20() {
        var tmp0 = this.q7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_method$_get_name_$ref_op8j2w(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.y7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      v7n(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.v7n(tmp, (value == null ? true : value instanceof PaymentTransferMethod()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_method$_get_serializer_$ref_4pnnb3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_method$_get_annotations_$ref_k4u13x(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_method', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_methodClass = $;
  }
  return ProjectLedgerItem_methodClass;
}
var ProjectLedgerItem_method_instance;
function ProjectLedgerItem_method_getInstance() {
  if (ProjectLedgerItem_method_instance === VOID)
    new (ProjectLedgerItem_method())();
  return ProjectLedgerItem_method_instance;
}
function ProjectLedgerItem_depositSucceeded$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(12);
}
function ProjectLedgerItem_depositSucceeded$_get_name_$ref_olqpcq() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_depositSucceeded$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_depositSucceeded$_get_serializer_$ref_4vbsx() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_depositSucceeded$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(12);
}
function ProjectLedgerItem_depositSucceeded$_get_annotations_$ref_kao8ez() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_depositSucceededClass;
function ProjectLedgerItem_depositSucceeded() {
  if (ProjectLedgerItem_depositSucceededClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_depositSucceeded_instance = this;
        var tmp = this;
        tmp.w7n_1 = lazy(ProjectLedgerItem_depositSucceeded$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7n_1 = lazy(ProjectLedgerItem_depositSucceeded$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7n_1 = lazy(ProjectLedgerItem_depositSucceeded$annotations$delegate$lambda);
        this.z7n_1 = null;
        this.a7o_1 = 'null';
      }
      i20() {
        var tmp0 = this.w7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_depositSucceeded$_get_name_$ref_olqpcq(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.z7k_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      b7o(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.b7o(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_depositSucceeded$_get_serializer_$ref_4vbsx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_depositSucceeded$_get_annotations_$ref_kao8ez(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_depositSucceeded', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_depositSucceededClass = $;
  }
  return ProjectLedgerItem_depositSucceededClass;
}
var ProjectLedgerItem_depositSucceeded_instance;
function ProjectLedgerItem_depositSucceeded_getInstance() {
  if (ProjectLedgerItem_depositSucceeded_instance === VOID)
    new (ProjectLedgerItem_depositSucceeded())();
  return ProjectLedgerItem_depositSucceeded_instance;
}
function ProjectLedgerItem_payoutRequested$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(13);
}
function ProjectLedgerItem_payoutRequested$_get_name_$ref_3qbmd() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_payoutRequested$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_payoutRequested$_get_serializer_$ref_vuluge() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_payoutRequested$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(13);
}
function ProjectLedgerItem_payoutRequested$_get_annotations_$ref_n6gm22() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_payoutRequestedClass;
function ProjectLedgerItem_payoutRequested() {
  if (ProjectLedgerItem_payoutRequestedClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_payoutRequested_instance = this;
        var tmp = this;
        tmp.c7o_1 = lazy(ProjectLedgerItem_payoutRequested$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d7o_1 = lazy(ProjectLedgerItem_payoutRequested$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e7o_1 = lazy(ProjectLedgerItem_payoutRequested$annotations$delegate$lambda);
        this.f7o_1 = null;
        this.g7o_1 = 'null';
      }
      i20() {
        var tmp0 = this.c7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_payoutRequested$_get_name_$ref_3qbmd(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.a7l_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      b7o(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.b7o(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_payoutRequested$_get_serializer_$ref_vuluge(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_payoutRequested$_get_annotations_$ref_n6gm22(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_payoutRequested', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_payoutRequestedClass = $;
  }
  return ProjectLedgerItem_payoutRequestedClass;
}
var ProjectLedgerItem_payoutRequested_instance;
function ProjectLedgerItem_payoutRequested_getInstance() {
  if (ProjectLedgerItem_payoutRequested_instance === VOID)
    new (ProjectLedgerItem_payoutRequested())();
  return ProjectLedgerItem_payoutRequested_instance;
}
function ProjectLedgerItem_payoutConfirmation$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(14);
}
function ProjectLedgerItem_payoutConfirmation$_get_name_$ref_wssicy() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_payoutConfirmation$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_payoutConfirmation$_get_serializer_$ref_6xq3yx() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_payoutConfirmation$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(14);
}
function ProjectLedgerItem_payoutConfirmation$_get_annotations_$ref_i1ubnn() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_payoutConfirmationClass;
function ProjectLedgerItem_payoutConfirmation() {
  if (ProjectLedgerItem_payoutConfirmationClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_payoutConfirmation_instance = this;
        var tmp = this;
        tmp.h7o_1 = lazy(ProjectLedgerItem_payoutConfirmation$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i7o_1 = lazy(ProjectLedgerItem_payoutConfirmation$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j7o_1 = lazy(ProjectLedgerItem_payoutConfirmation$annotations$delegate$lambda);
        this.k7o_1 = null;
        this.l7o_1 = 'null';
      }
      i20() {
        var tmp0 = this.h7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_payoutConfirmation$_get_name_$ref_wssicy(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.b7l_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      b7o(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.b7o(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_payoutConfirmation$_get_serializer_$ref_6xq3yx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_payoutConfirmation$_get_annotations_$ref_i1ubnn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_payoutConfirmation', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_payoutConfirmationClass = $;
  }
  return ProjectLedgerItem_payoutConfirmationClass;
}
var ProjectLedgerItem_payoutConfirmation_instance;
function ProjectLedgerItem_payoutConfirmation_getInstance() {
  if (ProjectLedgerItem_payoutConfirmation_instance === VOID)
    new (ProjectLedgerItem_payoutConfirmation())();
  return ProjectLedgerItem_payoutConfirmation_instance;
}
function ProjectLedgerItem_accountName$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(15);
}
function ProjectLedgerItem_accountName$_get_name_$ref_d1b7a3() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_accountName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[15];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_accountName$_get_serializer_$ref_atba0u() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_accountName$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(15);
}
function ProjectLedgerItem_accountName$_get_annotations_$ref_z0kcau() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_accountNameClass;
function ProjectLedgerItem_accountName() {
  if (ProjectLedgerItem_accountNameClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_accountName_instance = this;
        var tmp = this;
        tmp.m7o_1 = lazy(ProjectLedgerItem_accountName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n7o_1 = lazy(ProjectLedgerItem_accountName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o7o_1 = lazy(ProjectLedgerItem_accountName$annotations$delegate$lambda);
        this.p7o_1 = null;
        this.q7o_1 = 'null';
      }
      i20() {
        var tmp0 = this.m7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_accountName$_get_name_$ref_d1b7a3(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.c7l_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      p7n(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.p7n(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_accountName$_get_serializer_$ref_atba0u(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_accountName$_get_annotations_$ref_z0kcau(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_accountName', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_accountNameClass = $;
  }
  return ProjectLedgerItem_accountNameClass;
}
var ProjectLedgerItem_accountName_instance;
function ProjectLedgerItem_accountName_getInstance() {
  if (ProjectLedgerItem_accountName_instance === VOID)
    new (ProjectLedgerItem_accountName())();
  return ProjectLedgerItem_accountName_instance;
}
function ProjectLedgerItem_intentId$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(16);
}
function ProjectLedgerItem_intentId$_get_name_$ref_7og2by() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_intentId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[16];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_intentId$_get_serializer_$ref_bkgmlx() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_intentId$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(16);
}
function ProjectLedgerItem_intentId$_get_annotations_$ref_jkg9if() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_intentIdClass;
function ProjectLedgerItem_intentId() {
  if (ProjectLedgerItem_intentIdClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_intentId_instance = this;
        var tmp = this;
        tmp.r7o_1 = lazy(ProjectLedgerItem_intentId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s7o_1 = lazy(ProjectLedgerItem_intentId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t7o_1 = lazy(ProjectLedgerItem_intentId$annotations$delegate$lambda);
        this.u7o_1 = null;
        this.v7o_1 = 'null';
      }
      i20() {
        var tmp0 = this.r7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_intentId$_get_name_$ref_7og2by(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.d7l_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      p7n(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.p7n(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_intentId$_get_serializer_$ref_bkgmlx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_intentId$_get_annotations_$ref_jkg9if(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_intentId', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_intentIdClass = $;
  }
  return ProjectLedgerItem_intentIdClass;
}
var ProjectLedgerItem_intentId_instance;
function ProjectLedgerItem_intentId_getInstance() {
  if (ProjectLedgerItem_intentId_instance === VOID)
    new (ProjectLedgerItem_intentId())();
  return ProjectLedgerItem_intentId_instance;
}
function ProjectLedgerItem_check$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(17);
}
function ProjectLedgerItem_check$_get_name_$ref_7vd0s5() {
  return (p0) => p0.i20();
}
function ProjectLedgerItem_check$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[17];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectLedgerItem_check$_get_serializer_$ref_qsa5ou() {
  return (p0) => p0.h2j();
}
function ProjectLedgerItem_check$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(17);
}
function ProjectLedgerItem_check$_get_annotations_$ref_wwt852() {
  return (p0) => p0.bz();
}
var ProjectLedgerItem_checkClass;
function ProjectLedgerItem_check() {
  if (ProjectLedgerItem_checkClass === VOID) {
    class $ {
      constructor() {
        ProjectLedgerItem_check_instance = this;
        var tmp = this;
        tmp.w7o_1 = lazy(ProjectLedgerItem_check$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7o_1 = lazy(ProjectLedgerItem_check$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7o_1 = lazy(ProjectLedgerItem_check$annotations$delegate$lambda);
        this.z7o_1 = null;
        this.a7p_1 = 'null';
      }
      i20() {
        var tmp0 = this.w7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectLedgerItem_check$_get_name_$ref_7vd0s5(), null);
        return tmp0.f2();
      }
      m7k(receiver) {
        return receiver.e7l_1;
      }
      k2j(receiver) {
        return this.m7k(receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE());
      }
      n7m(receiver, value) {
        return receiver.h7l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectLedgerItem() ? receiver : THROW_CCE();
        return this.n7m(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectLedgerItem_check$_get_serializer_$ref_qsa5ou(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectLedgerItem_check$_get_annotations_$ref_wwt852(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectLedgerItem_check', VOID, VOID, [SerializableProperty()]);
    ProjectLedgerItem_checkClass = $;
  }
  return ProjectLedgerItem_checkClass;
}
var ProjectLedgerItem_check_instance;
function ProjectLedgerItem_check_getInstance() {
  if (ProjectLedgerItem_check_instance === VOID)
    new (ProjectLedgerItem_check())();
  return ProjectLedgerItem_check_instance;
}
//region block: exports
export {
  get_amount as get_amount3tpau2iir7fhe,
  get_created as get_created3mwbwy01g8dq,
  get_party as get_partyq13c2hdc8rqy,
  prepareProjectLedgerItemFields as prepareProjectLedgerItemFieldswo0bcmjprn3g,
  get_project as get_project24re8n4hoe63y,
  get_state as get_state3dimnrbngbj36,
};
//endregion

//# sourceMappingURL=ProjectLedgerItemFields.mjs.map
